import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import theme from "./util/theme";
import './index.css';
import App from './App';
import './locales/i18n';
import { LOCALE } from './api/client';
import { SiteProvider } from './site/SiteContext';
// import the weights you need to avoid bundling everything
import "@fontsource/cairo/400.css";
import "@fontsource/cairo/600.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/700.css";

// English pages live at /about, Arabic ones at /ar/about: the router works
// inside that prefix, so every <Link to="/about"> keeps the current language.
const basename = LOCALE === 'ar' ? '/ar' : '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <ThemeProvider theme={{ ...theme, direction: LOCALE === 'ar' ? 'rtl' : 'ltr' }}>
        <SnackbarProvider
          anchorOrigin={{ vertical: 'top', horizontal: LOCALE === 'ar' ? 'left' : 'right' }} >
          <SiteProvider>
            <App />
          </SiteProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
